const FALLBACK_AVATAR = 'https://api.dicebear.com/7.x/avataaars/svg?seed=default';

export const resolveActorProfile = (actorKey, usersList = []) => {
  const key = String(actorKey || '');
  if (!key) return null;
  const matched = usersList.find((user) =>
    [
      user.id,
      user.uid,
      user.phone,
      user._id,
      user.userId,
      ...(Array.isArray(user.legacyUids) ? user.legacyUids : [])
    ]
      .filter(Boolean)
      .some((value) => String(value) === key)
  );
  if (matched) {
    return {
      id: matched.id || matched._id,
      uid: matched.uid,
      phone: matched.phone,
      name: matched.name || `用户_${String(matched.uid || key).slice(-4)}`,
      avatar: matched.avatar || FALLBACK_AVATAR
    };
  }
  return {
    id: key,
    uid: key.length === 8 ? key : '',
    phone: '',
    name: key.length === 8 ? `用户 ${key}` : `用户_${key.slice(-4)}`,
    avatar: FALLBACK_AVATAR
  };
};

export const resolveActors = (keys, usersList = []) =>
  (Array.isArray(keys) ? keys : [])
    .map((key) => resolveActorProfile(key, usersList))
    .filter(Boolean);

export const getWorkInteractionCounts = (post) => ({
  likes: Array.isArray(post?.likedBy) ? post.likedBy.length : Number(post?.likes || 0),
  bookmarks: Array.isArray(post?.bookmarkedBy) ? post.bookmarkedBy.length : 0,
  comments: Array.isArray(post?.comments) ? post.comments.length : Number(post?.commentsCount || 0)
});

export const buildWorkInteractionSummary = (post, usersList = []) => ({
  counts: getWorkInteractionCounts(post),
  likers: resolveActors(post?.likedBy, usersList),
  bookmarkers: resolveActors(post?.bookmarkedBy, usersList),
  comments: (Array.isArray(post?.comments) ? post.comments : []).map((comment) => ({
    ...comment,
    actor: resolveActorProfile(comment.userId || comment.uid || comment.phone, usersList)
  }))
});
